<div class="register-container">
  <div class="logo-container">
    <img class="logo-safecloud-1" src="../../assets/img/safecloud-1.png" alt="logo">
  </div>
  <div class="message">
    <h5>REGISTRATION COMPLETE</h5>
    <span>An email will be sent to the address {{ email }} once your account setup is done.</span>
    <a href="https://safecloudsinglar.com/">Portal Safecloud</a>
  </div>
</div>
